import Link from 'next/link';
import { Button } from '@components/common/button';
import { menus } from '@components/common/footer/constants';
import { companyInfo } from '@libraries/common/companyInfo';
import SteadioFullLogo from '@assets/svgs/logo/SteadioFullLogo.svg';

const {
  startCreator,
  communityPolicy,
  contactUs,
  helpCenter,
  instagram,
  kakaotalk,
  operatingHours,
  privacyPolicy,
  serviceIntroduction,
  termsOfUse,
  twitter,
  notice,
  creatorGuide,
} = menus;

const {
  address,
  ceo,
  companyName,
  coporateRegistrationNumber,
  copyright,
  mainPhoneNumber,
  onlineMarketingRegistrationNumber,
} = companyInfo;

export default function MobileMainFooter() {
  return (
    <div className="pt-[32px] pb-[24px] px-[16px]">
      <SteadioFullLogo className="w-[114px] h-[16px] content_secondary" />
      <div className="mt-[24px] flex flex-wrap gap-x-[16px] gap-y-[12px]">
        <MobileMenuLink href={startCreator.link} name={startCreator.name} />
        <MobileMenuLink
          href={serviceIntroduction.link}
          name={serviceIntroduction.name}
        />
        <MobileMenuLink href={notice.link} name={notice.name} />
        <MobileMenuLink href={helpCenter.link} name={helpCenter.name} />
        <MobileMenuLink href={creatorGuide.link} name={creatorGuide.name} />
        <MobileMenuLink href={termsOfUse.link} name={termsOfUse.name} />
        <MobileMenuLink href={privacyPolicy.link} name={privacyPolicy.name} />
        <MobileMenuLink
          href={communityPolicy.link}
          name={communityPolicy.name}
        />
      </div>
      <div className="mt-[16px] pb-[16px] border-b border_primary content_secondary  ">
        <h5 className="font_label_bold_xl">고객지원</h5>
        <p className="mt-[8px] font_label_regular_lg">{operatingHours.name}</p>
        <Link href={contactUs.link}>
          <a target="_blank" className="block mt-[8px]">
            <Button shape="rect" size="medium" color="outline">
              스테디오에 문의
            </Button>
          </a>
        </Link>
      </div>
      <div className="mt-[16px] content_quaternary leading-none">
        <CompanyInfo title={companyName.title} value={companyName.value} />
        <CompanyInfo title={address.title} value={address.value} />
        <CompanyInfo title={ceo.title} value={ceo.value} />
        <CompanyInfo
          title={coporateRegistrationNumber.title}
          value={coporateRegistrationNumber.value}
        />
        <CompanyInfo
          title={onlineMarketingRegistrationNumber.title}
          value={onlineMarketingRegistrationNumber.value}
        />
        <CompanyInfo
          title={mainPhoneNumber.title}
          value={mainPhoneNumber.value}
        />
      </div>
      <p className="mt-[8px] font_label_regular_md content_tertiary">
        {copyright.value}
      </p>
      <div className="mt-[16px] flex">
        <SocialLink href={kakaotalk.link} icon={kakaotalk.icon} />
        <SocialLink href={twitter.link} icon={twitter.icon} />
        <SocialLink href={instagram.link} icon={instagram.icon} />
      </div>
    </div>
  );
}

type MobileMenuLinkProps = {
  href: string;
  name: string;
};

const MobileMenuLink = ({ href, name }: MobileMenuLinkProps) => (
  <Link href={href}>
    <a target="_blank" className="content_tertiary font_label_bold_lg">
      {name}
    </a>
  </Link>
);

type CompanyInfoProps = {
  title: string;
  value: string;
};

const CompanyInfo = ({ title, value }: CompanyInfoProps) => (
  <>
    <span className="font_label_bold_sm">{title} </span>
    <span className="font_label_regular_sm">{value} </span>
  </>
);

type SocialLinkProps = {
  href: string;
  icon: any;
};

const SocialLink = ({ href, icon }: SocialLinkProps) => (
  <Link href={href}>
    <a target="_blank" className="ml-[20px] first:m-0">
      {icon({
        className: 'w-[24px] h-[24px] content_secondary',
      })}
    </a>
  </Link>
);
